var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageLevel2EmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 210,
    viewBox: "0 0 500 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3426_5126)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 210,
    rx: 10,
    fill: "#101214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.9297H500V210H0V36.9297Z",
    fill: "#101214",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 142.055,
    width: 55.9161,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 164.461,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 185,
    width: 70.4691,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.848,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.92,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.992,
    y: 109.648,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.818,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.859,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.901,
    y: 14.4961,
    width: 104.323,
    height: 10,
    rx: 5,
    fill: "#9FADBC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.408 50.0484L476.224 53.2334L473.038 50.0474C472.943 49.9543 472.815 49.9024 472.682 49.9029C472.548 49.9035 472.421 49.9565 472.326 50.0504L471.626 50.7514C471.578 50.7974 471.54 50.8525 471.514 50.9135C471.488 50.9745 471.474 51.0402 471.474 51.1066C471.473 51.173 471.486 51.2388 471.512 51.3001C471.537 51.3614 471.575 51.4169 471.622 51.4634L474.807 54.6474L471.623 57.8334C471.53 57.9288 471.478 58.057 471.479 58.1903C471.48 58.3235 471.533 58.4511 471.627 58.5454L472.327 59.2454C472.533 59.4524 472.843 59.4454 473.039 59.2494L476.225 56.0644L479.409 59.2494C479.505 59.3425 479.633 59.3942 479.766 59.3935C479.899 59.3927 480.027 59.3395 480.121 59.2454L480.822 58.5454C480.87 58.4994 480.908 58.4442 480.934 58.3832C480.96 58.3221 480.974 58.2565 480.974 58.1901C480.975 58.1237 480.962 58.0579 480.936 57.9966C480.91 57.9354 480.873 57.8799 480.825 57.8334L477.639 54.6474L480.825 51.4634C480.918 51.3682 480.97 51.2401 480.97 51.1068C480.969 50.9736 480.916 50.8459 480.822 50.7514L480.122 50.0514C480.075 50.0034 480.019 49.9652 479.957 49.9389C479.896 49.9126 479.829 49.8989 479.762 49.8984C479.696 49.899 479.631 49.9125 479.571 49.9382C479.51 49.964 479.455 50.0014 479.409 50.0484H479.408Z",
    fill: "#9FADBC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.000122158,
    y1: 36.2422,
    x2: 500,
    y2: 36.2422,
    stroke: "#9FADBC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.7766,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1319 63.1562C51.1319 67.0696 47.9594 70.2421 44.046 70.2421C40.1325 70.2421 36.9601 67.0696 36.9601 63.1562C36.9601 59.2428 40.1325 56.0703 44.046 56.0703C47.9594 56.0703 51.1319 59.2428 51.1319 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.868 73.1771C63.1839 72.5255 62.1088 72.5255 61.4246 73.1771L49.78 84.2672L46.2236 80.4765C45.5238 79.7306 44.3396 79.7306 43.6398 80.4765L37.7589 86.7448C36.6976 87.876 37.4997 89.7283 39.0508 89.7283H76.8181C78.4172 89.7283 79.1978 87.7769 78.0398 86.674L63.868 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.848,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.204 63.1562C146.204 67.0696 143.031 70.2421 139.118 70.2421C135.204 70.2421 132.032 67.0696 132.032 63.1562C132.032 59.2428 135.204 56.0703 139.118 56.0703C143.031 56.0703 146.204 59.2428 146.204 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.94 73.1771C158.256 72.5255 157.18 72.5255 156.496 73.1771L144.852 84.2672L141.295 80.4765C140.595 79.7306 139.411 79.7306 138.711 80.4765L132.831 86.7448C131.769 87.876 132.571 89.7283 134.122 89.7283H171.89C173.489 89.7283 174.269 87.7769 173.111 86.674L158.94 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.92,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.276 63.1562C241.276 67.0696 238.103 70.2421 234.19 70.2421C230.276 70.2421 227.104 67.0696 227.104 63.1562C227.104 59.2428 230.276 56.0703 234.19 56.0703C238.103 56.0703 241.276 59.2428 241.276 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.012 73.1771C253.328 72.5255 252.252 72.5255 251.568 73.1771L239.924 84.2672L236.367 80.4765C235.668 79.7306 234.483 79.7306 233.783 80.4765L227.903 86.7448C226.841 87.876 227.643 89.7283 229.195 89.7283H266.962C268.561 89.7283 269.341 87.7769 268.183 86.674L254.012 73.1771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.992,
    y: 47.8984,
    width: 80,
    height: 50,
    rx: 5,
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.348 63.1562C336.348 67.0696 333.175 70.2421 329.262 70.2421C325.348 70.2421 322.176 67.0696 322.176 63.1562C322.176 59.2428 325.348 56.0703 329.262 56.0703C333.175 56.0703 336.348 59.2428 336.348 63.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.084 73.1771C348.4 72.5255 347.325 72.5255 346.64 73.1771L334.996 84.2672L331.439 80.4765C330.74 79.7306 329.555 79.7306 328.856 80.4765L322.975 86.7448C321.913 87.876 322.716 89.7283 324.267 89.7283H362.034C363.633 89.7283 364.414 87.7769 363.256 86.674L349.084 73.1771Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 498,
    height: 208,
    rx: 9,
    stroke: "#9FADBC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3426_5126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 210,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLevel2EmptyDark);
export default __webpack_public_path__ + "static/media/Image-level2-empty-dark.0fe7959ac7437e634d7f095753ae550c.svg";
export { ForwardRef as ReactComponent };